var map = {
	"./github-light.svg": 36,
	"./github.svg": 37,
	"./linkedin-light.svg": 38,
	"./linkedin.svg": 39,
	"./mail-light.svg": 40,
	"./mail.svg": 41,
	"./ward-icon-illuminated.svg": 42,
	"./ward-icon.svg": 43
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 35;